@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';

@limited-page-width: 780px;
@subscription-page-width: 1136px;

@settings-page--background-color: var(--Surface-Default);

@settings-page-content-padding: @space-0 @space-24 @space-24 @space-24;

@settings-page--tabbed--padding: @space-0;

@settings-page--tabbed--header--background-color: var(--Surface-Container);
@settings-page--tabbed--header--padding: @space-0 @space-24 @space-16 @space-24;
@settings-page--tabbed--header--title-only--padding: @space-0 @space-24;

@settings-page--tabbed--tab-panel--background-color: var(--Surface-Default);
@settings-page--tabbed--tab-panel--padding: @space-24;

@settings-page--table--border-color: var(--table--border-color--2);
@settings-page--table--border: 1px solid @settings-page--table--border-color;
@settings-page--table--font-size: 14px;
@settings-page--table--line-height: 24px;

@settings-page--table--cell--padding: @space-8 @space-16;

@settings-page--table--header--cell--background-color: var(--table--header--cell--background-color--1);
@settings-page--table--header--cell--text-color: var(--table--header--cell--text-color--1);
@settings-page--table--header--cell--font-weight: 500;

@settings-page--table--body--cell--background-color: var(--table--body--cell--background-color--1);
@settings-page--table--body--cell--text-color: var(--table--body--cell--text-color--1);

.settings-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
  .toggle-icon {
    top: 14px;
  }
}

.leftnav {
  > :first-child {
    overflow-y: auto;
  }
}

.add-ons-nav-item-label {
  display: inline-flex;
  align-items: center;
  gap: @space-8;
}

.page-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  background-color: @settings-page--background-color;

  // TODO: This is a temporary class and will be removed with  JIRA Ticket SPD-16579
  .header-level-3 {
    margin: 0;
  }

  // TODO: JIRA Ticket SPD-16579 - remove or replace these type selectors with a class selector
  h3 {
    font-size: 20px;
    font-weight: @normal;
    margin: 16px 0;
  }
}

.content {
  flex-grow: 1;
  padding: @settings-page-content-padding;
  max-height: 100%;
  overflow-y: auto;
  height: 100%;
}

.tabbed-content {
  flex-grow: 1;
  max-height: 100%;
  overflow-y: auto;
  height: 100%;
  padding: @settings-page--tabbed--padding;
  background-color: @settings-page--tabbed--header--background-color;
}

.tabbed-header-section {
  color: var(--grey-900);
  padding: @settings-page--tabbed--header--title-only--padding;

  &.has-additional-content {
    padding: @settings-page--tabbed--header--padding;
  }
}

.settings-section {
  max-width: @limited-page-width;
  margin-right: 72px;
  color: @settings-page--section--text-color;
  padding: @settings-page-content-padding;
}

.loading {
  height: 100%;
  width: 100%;
}

.header {
  padding-bottom: 20px;
  border-bottom: 1px solid @settings-page--general-header--border-color;
}

.content-wrapper {
  width: 100%;
  overflow: auto;
}

.instructions {
  padding: 2px 0;
  color: @settings-page--instructions--text-color;
  font-size: 12px;
}

.limited-width-page {
  max-width: @limited-page-width;
}

.description-section {
  display: flex;
  gap: @space-32;
  margin-bottom: @space-24;
  max-width: 725px;
  color: var(--grey-900);
}

.grid {
  display: grid;
  overflow: hidden;
  background: @settings-page--table--body--cell--background-color;
}

.header-cell {
  background-color: @settings-page--table--header--cell--background-color;
  padding: @settings-page--table--cell--padding;
  border-top: @settings-page--table--border;
  border-bottom: @settings-page--table--border;
  text-align: center;
  color: @settings-page--table--header--cell--text-color;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
  font-weight: @settings-page--table--header--cell--font-weight;
}

.left-header-cell {
  .header-cell();
  border-left: @settings-page--table--border;
  text-align: left;
}

.right-header-cell {
  .header-cell();
  border-right: @settings-page--table--border;
}

.grid-cell {
  position: relative;
  padding: @settings-page--table--cell--padding;
  border-bottom: @settings-page--table--border;
  text-align: center;
  z-index: 2;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
  background: @settings-page--table--body--cell--background-color;
  color: @settings-page--table--body--cell--text-color;
}

.left-grid-cell {
  .grid-cell();
  border-left: @settings-page--table--border;
  text-align: left;

  img {
    height: 16px;
    width: 16px;
    vertical-align: top;
  }

  span {
    padding-left: 15px;
  }

  button {
    text-align: left;
  }
}

.right-grid-cell {
  .grid-cell();
  border-right: @settings-page--table--border;
}

.nav-item-with-badge {
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
